import React from 'react';

const DepositionStages = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 43.161 85.549"
			className={className}
		>
			<g fill="currentColor">
				<path d="M25.356 39.68v-14h-7.55v14a7.262 7.262 0 0 0-2.34 2.321 7.179 7.179 0 0 0-1.1 3.817v.032a7.1 7.1 0 0 0 .544 2.693 7.329 7.329 0 0 0 2.465 3.116 7.142 7.142 0 0 0 3.822 1.358c.125.006.252.009.377.009a7.207 7.207 0 0 0 3.774-13.348Zm.009 9.921a5.332 5.332 0 0 1-3.784 1.57c-.093 0-.187 0-.283-.008a5.215 5.215 0 0 1-1.967-.5 5.472 5.472 0 0 1-2.233-1.95 5.29 5.29 0 0 1-.871-2.875v-.025a5.313 5.313 0 0 1 .812-2.832 5.405 5.405 0 0 1 2.116-1.941l.506-.258V27.538h3.838v2.117h-1.92v1.237h1.92v1.378h-1.92v1.237h1.92v1.378h-1.92v1.237h1.92v4.664l.506.258a5.42 5.42 0 0 1 2.117 1.941 5.342 5.342 0 0 1-.756 6.616Z" />
				<path d="M22.199 42.89v-4.77h-1.237v4.77a3.024 3.024 0 1 0 1.237 0Z" />
				<path d="M43.161 58.816V20.28H28.12V0H15.04v20.28H0v38.536h6.356v5.031H0v10.312h43.161V63.847h-6.356v-5.031ZM18.135 3.093h6.891V20.28h-6.891ZM40.068 66.94v4.128H3.093V66.94ZM3.093 55.723v-32.35h36.975v32.349Zm30.617 3.093v5.031H9.449v-5.031Z" />
				<path d="m1.795 80.17-.5 1.132a50.61 50.61 0 0 0 35.743 1.831l.837 2.2 3.737-4.593-5.846-.94.83 2.179a49.372 49.372 0 0 1-34.8-1.8Z" />
			</g>
		</svg>
	);
};

export default DepositionStages;
